import React from "react";
import { IProps } from '../../theme/interface/common';
import { CERTIFICATE_TYPE } from '../../theme/interface/index';
import { defaultThemeInfo, getTranslateThemeInfo, getThemeIndex } from '../../theme/dataflow/index';
import { themeList, enterpriseThemeList } from '../../theme/index';

const ThemeBasicInfo = (props: IProps) => {
    const { isShowCertificateInfo, enterpriseCertificateInfo, enterpriseExpendData, themeInfo, scaleRatio = 1 } = props;
    const newThemeInfo = isShowCertificateInfo
        ? getTranslateThemeInfo(enterpriseCertificateInfo, enterpriseExpendData)
        : (themeInfo || defaultThemeInfo);
    const {
        themeType = CERTIFICATE_TYPE.ENTERPRISE,
        themeStyleType = '0-1',// 默认为企业证书且取第一个默认样式
    } = newThemeInfo;
    const {themeIndex, themeType: newThemeType} = getThemeIndex(themeType, themeStyleType);
    const themeCardList = themeList[newThemeType] || enterpriseThemeList;
    const ThemeCard = themeCardList[themeIndex % themeCardList.length];
    return <ThemeCard themeInfo={newThemeInfo} onConfigChange={props.onConfigChange} scaleRatio={scaleRatio}></ThemeCard>
};
export {
    ThemeBasicInfo
}
